export default __webpack_public_path__ + "static/media/wrong.5a4e5cf8.jpg";